/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/caravan_medium'
export default icon
